let CONSTS = {
	//静态常量放在这里
	BASE_URL: ""
}
let env = process.env.NODE_ENV;
if (env == 'development') {
	CONSTS.BASE_URL = "http://221.10.90.164:8095"  //生产环境服务器
	// CONSTS.BASE_URL = "http://221.10.90.153:9082" //开发环境服务器
	// CONSTS.BASE_URL = "http://192.168.31.103:2404" //局域网本地后端服务器
} else if (env == 'production') {
	CONSTS.BASE_URL = "http://221.10.90.164:8095"
	// CONSTS.BASE_URL = "http://221.10.90.153:9082" //开发打包端口
}
export default CONSTS